if (!Enum) {
    var Enum = {};
}

Enum.VISIT_TYPE = {
    INTERN: "INTERN",
    GYNECOLOGICAL: "GYNECOLOGICAL",
    CARDIOLOGICAL: "CARDIOLOGICAL",
    LARYNGOLOGICAL: "LARYNGOLOGICAL",
    NEUROLOGICAL: "NEUROLOGICAL",
    OPTHALMOLOGIC: "OPTHALMOLOGIC",
    ONCOLOGIC: "ONCOLOGIC",
    ORTOPEDIC: "ORTOPEDIC",
    VIDEOCONSULTATION: "VIDEOCONSULTATION",
    ICF: "ICF"
};

Object.freeze(Enum.VISIT_TYPE);